// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"10":"11239354","257":"111199df","278":"3382cb4a","284":"10a0edfd","453":"ff7866cb","528":"12a8a30c","635":"647ea2ea","653":"2fd5bafa","718":"d6104b18","735":"146d8c28","904":"7c5ce3e7"}[chunkId] + ".chunk.js";
};